import script from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionField.vue?vue&type=script&setup=true&lang=js"

export default script